<template>
  <beer class="experimental" itemId="2000000007" itemName="brownie" title="Brownie, 20 °P, Pastry Stout">
    <p
      style="
          margin: auto;
          text-align: justify;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      Silné hutné pivo s krémovou konzistencí díky přidané laktóze. Použité slady se postaraly o příjemnou
      oříškovo-čokoládovou chuť, kterou jsme podpořili přidáním hromady kakaových bobů. Aby byl tento „dezert“ kompletní
      přidali jsme nakonec ještě vanilku!
    </p>

    <table
      class="tg"
      style="
          margin: auto;
          text-align: left;
          max-width: 40rem;
          width: 100%;
          margin-top: 4rem;
        "
    >
      <tbody>
        <tr>
          <td class="bold">Pivní styl</td>
          <td class="right">Pastry Stout</td>
        </tr>
        <tr>
          <td>Stupňovitost</td>
          <td class="right">20 °P</td>
        </tr>
        <tr>
          <td>Alkohol</td>
          <td class="right">8 %</td>
        </tr>
        <tr>
          <td>Barva</td>
          <td class="right">36 SRM</td>
        </tr>
        <tr>
          <td>Hořkost</td>
          <td class="right">30 IBU</td>
        </tr>
        <tr>
          <td>Slady</td>
          <td class="right">Marris Otter, světlý, čokoládový světlý a tmavý, ovesné vločky</td>
        </tr>
        <tr>
          <td>Chmely</td>
          <td class="right">East Kent Goldings, Fuggles</td>
        </tr>
      </tbody>
    </table>
  </beer>
</template>
<script>
import Beer from "../Beer";
export default {
  name: "Brownie",
  components: { Beer },
};
</script>
